import React from "react";
import ReactDOM from "react-dom";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import FAQPage from "./pages/FAQPage";
import AboutUsPage from "./pages/AboutUsPage";
import ContactUsPage from "./pages/ContactUsPage";
import PricePage from "./pages/PricePage";

const routing = (
    <Router>
        <div>
            <Switch>
                <Route exact path="/" component={App} />
                <Route path="/pages/faq" component={FAQPage} />
                <Route path="/pages/about_us" component={AboutUsPage} />
                <Route path="/pages/contact_us" component={ContactUsPage} />
                <Route path="/pages/price_page" component={PricePage} />
                <Route path='/external/client_area' component={() => {window.location.href = 'https://blesta.novuservers.com/'; return null;}}/>
                <Route path='/external/server_panel' component={() => {window.location.href = 'https://pterodactyl.novuservers.com/'; return null;}}/>
                {/* <Route path="/pages/" component={} />
                <Route path="/pages/" component={} /> */}
            </Switch>
        </div>
    </Router>
);

ReactDOM.render(routing, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
